export default {
  setting: "Setting",
  personalSetting: "PersonalSetting",
};
